module.exports = __webpack_public_path__ + "static/img/icon_thumb_b.7ffeb2d4.svg";